<template>
    <div class="col-md-6" >
        <label class="attribute-label m-bottom-12" :for="id">
            Select rate
        </label>
        <div class="width-100" >
            <select :name="name" class="form-control" v-model="selectedRate" @change="onChange($event)">
                <option value="">Select rate</option>
                <option v-for="rate in service.serviceRates" :selected="service.service_rate_id && service.service_rate_id === rate.service_rate_id" :value="rate.cost">
                    {{ rate.rate_title }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";

export default {
    name: "ServiceRate",
    props: {
        service: {
            type: Object,
            required: true
        },

    },
    data() {
        return {
            selectedRate: this.service.service_rate_id || '',
            default_value : 0
        }
    },
    computed: {
        /**
         * get unitAttribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.service.clone)) {
                return `service_rate_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_rate_${this.service.service_id}`;
        },
        /**
         * get unitAttribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.service.clone)) {
                return `service_rate_${this.service.service_id}_${this.service.clone}`;
            }

            return `service_rate_${this.service.service_id}`;
        }
    },
    methods: {
        onChange(event) {
            const selectedCost = event.target.value;
            const selectedRate = this.service.serviceRates.find(rate => rate.cost == selectedCost);
            if (selectedRate) {
                selectedRate.service_id = this.service.service_id
                selectedRate.clone = this.service.clone
                this.onClick(selectedRate);
            }
        },
        onClick(value) {
            EventBus.$emit('onUpdateServiceRate', {
                service_rate :value,
            })
        },
    },
}
</script>

<style scoped>
.price-new-inputs {
    border-radius: 8px !important;
}
</style>